import { Flex, Skeleton } from "@mantine/core";

const SkeletonPatient = () => {
  return (
    <Flex mt={10}>
      <Skeleton radius={"xl"} w={36} h={36} />
      <Flex>
        <Skeleton ml={10} w={200} h={36} />
      </Flex>
    </Flex>
  );
};
export default SkeletonPatient;
